import React from "react";
import { CardContainer, DriverName, DriverStatus, NameStatus } from "./style";
import Avatar from "../Avatar";
import { useNavigate } from "react-router-dom";

const statusMap = {
  AVAILABLE: "متاح",
  ONLINE: "اونلاين",
  IN_TRIP: "في الرحلة",
};

const DriverCard = ({ name, status, imageSrc, driverId }) => {
  const navigate = useNavigate();
  const translatedStatus = statusMap[status] || "غير معروف";

  const goToProfile = () => {
    navigate(`/driver-profile/${driverId}`);
  };

  return (
    <CardContainer onClick={goToProfile} style={{ cursor: "pointer" }}>
      <Avatar img={imageSrc} />
      <NameStatus>
        <DriverName>{name}</DriverName>
        <DriverStatus status={translatedStatus}>
          {translatedStatus}
        </DriverStatus>
      </NameStatus>
    </CardContainer>
  );
};

export default DriverCard;
